import { Box, Grid, Input, Typography } from '@mui/material'
import { memo, useState } from 'react'

const InstructionsForm = ({
  editStates,
  preparedQuote,
  updatePreparedQuote,
  updatePreparedAmend,
}: any) => {
  const [flightNumber, setFlightNumber] = useState(
    preparedQuote?.outbound?.flightDetails.flightNumber || '',
  )
  const [specialInstructions, setSpecialIntsructions] = useState(
    preparedQuote?.outbound?.specialInstructions || '',
  )
  const updateFlightNumber = (change: any) => {
    updatePreparedQuote('outbound', {
      ...preparedQuote.outbound,
      flightDetails: { flightNumber: change },
    })
    updatePreparedAmend('flightDetails', { flightNumber: change })
  }
  const updateSpecialInstructions = (change: any) => {
    updatePreparedQuote('outbound', {
      ...preparedQuote.outbound,
      specialInstructions: change,
    })
    updatePreparedAmend('specialInstructions', change)
  }
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '15px',
      }}
    >
      {!editStates.general ? (
        <Grid
          item
          xs={10}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            paddingLeft: '5px',
          }}
        >
          <Typography
            variant="body1"
            sx={{ fontWeight: 'bold', textTransform: 'uppercase' }}
          >
            Flight Number
          </Typography>
          <Typography variant="body2">
            {preparedQuote?.outbound?.flightDetails?.flightNumber || 'N/A'}
          </Typography>
          <Typography
            variant="body1"
            sx={{ fontWeight: 'bold', textTransform: 'uppercase' }}
          >
            Special Instructions
          </Typography>
          <Typography variant="body2">
            {preparedQuote?.outbound?.specialInstructions || 'N/A'}
          </Typography>
        </Grid>
      ) : (
        <>
          <Grid item xs={10}>
            <Typography
              variant="body1"
              sx={{
                fontWeight: 'bold',
                textTransform: 'uppercase',
                display: 'flex',
              }}
            >
              Flight Number
            </Typography>
            <Typography variant="body2">
              <Input
                fullWidth
                defaultValue={flightNumber}
                onChange={(e) => setFlightNumber(e.target.value)}
                onBlur={(e) => {
                  updateFlightNumber(e.target.value)
                }}
              />
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontWeight: 'bold',
                textTransform: 'uppercase',
                display: 'flex',
              }}
            >
              Special Instructions
            </Typography>
            <Typography variant="body2">
              <Input
                fullWidth
                multiline
                rows={3}
                sx={{ overflow: 'auto' }}
                defaultValue={specialInstructions}
                onChange={(e) => setSpecialIntsructions(e.target.value)}
                onBlur={(e) => {
                  updateSpecialInstructions(e.target.value)
                }}
              />
            </Typography>
          </Grid>
        </>
      )}
    </Box>
  )
}

export default memo(InstructionsForm)
